import React from 'react';
import ShoppingBagIcon from '@moda/icons/shopping-bag-24';
import { useCart } from '../../hooks/useCart';
import { Link } from '../Link';
import { hrefFor } from '../../routers';
import './MiniCartLink.scss';

export const MiniCartLink: React.FC = () => {
  const {
    cart: {
      attributes: { cartItemsCount }
    }
  } = useCart();

  return (
    <Link className="MiniCartLink" to={hrefFor.ShoppingBagPage()} aria-label="Shopping Bag">
      <ShoppingBagIcon />
      {cartItemsCount > 0 && `(${cartItemsCount})`}
    </Link>
  );
};
